"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasOpenRequestInWindow = exports.holderLimitReached = exports.defaultTier = exports.HOLDER_LIMITS = exports.newShareholderKycRefusal = exports.KYC_EXPIRED_MESSAGE = exports.KYC_DATES_REQUIRED_MESSAGE = exports.isKycExpired = exports.hasCompleteKycDates = exports.isLegacyPdtiCompany = exports.PDTI_FULL_LEGACY_CUTOFF = void 0;
const dealingWindow_1 = require("../contracts/dealingWindow");
const formatting_1 = require("./formatting");
/*
 * Rules an investor's new subscription or redemption is held to, shared by the API (which enforces them) and the
 * web (which refuses before the investor signs a stablecoin request).
 */
/** Funds created before this date keep their own KYC regime and are not held to KYC dates. */
exports.PDTI_FULL_LEGACY_CUTOFF = new Date("2026-06-01T00:00:00.000Z");
const isLegacyPdtiCompany = (createdAt) => {
    if (!createdAt) {
        return false;
    }
    const createdAtDate = createdAt instanceof Date ? createdAt : new Date(createdAt);
    return !Number.isNaN(createdAtDate.getTime()) && createdAtDate < exports.PDTI_FULL_LEGACY_CUTOFF;
};
exports.isLegacyPdtiCompany = isLegacyPdtiCompany;
const hasCompleteKycDates = (kyc) => Boolean(kyc?.verificationDate && kyc?.expiryDate);
exports.hasCompleteKycDates = hasCompleteKycDates;
const isKycExpired = (expiryDate) => (0, formatting_1.convertDateToUtcAtMidnight)(expiryDate) < (0, formatting_1.convertDateToUtcAtMidnight)(new Date());
exports.isKycExpired = isKycExpired;
exports.KYC_DATES_REQUIRED_MESSAGE = "KYC verification and expiry dates are required";
exports.KYC_EXPIRED_MESSAGE = "Shareholder KYC has expired";
/**
 * Why units cannot be issued to a holding under its KYC dates, or null when they can. A legacy fund
 * (`isLegacyPdtiCompany`) is not held to KYC dates.
 */
const newShareholderKycRefusal = (kyc, legacyCompany) => {
    if (legacyCompany) {
        return null;
    }
    if (!(0, exports.hasCompleteKycDates)(kyc)) {
        return exports.KYC_DATES_REQUIRED_MESSAGE;
    }
    return (0, exports.isKycExpired)(kyc?.expiryDate) ? exports.KYC_EXPIRED_MESSAGE : null;
};
exports.newShareholderKycRefusal = newShareholderKycRefusal;
/** The most active holders a fund's plan tier allows. */
exports.HOLDER_LIMITS = {
    tier1: 20,
    tier2: 50,
    tier3: 250,
    tier4: Infinity,
};
/** The fund's tier: the one stored, else plan 1's smallest and every other plan's unlimited one. */
const defaultTier = (planName = "plan1", tierName) => (tierName ?? (planName === "plan1" ? "tier1" : "tier4"));
exports.defaultTier = defaultTier;
/** True when the fund already has as many active holders as its tier allows, so a new holder is refused. */
const holderLimitReached = (tier, activeHolders) => activeHolders >= exports.HOLDER_LIMITS[tier];
exports.holderLimitReached = holderLimitReached;
/**
 * Whether one of the holding's open requests on the class blocks a new one: one open request per class per dealing
 * window, and an unstamped request blocks too, because it joins whichever window runs when it is accepted.
 * `openRows` are the holding's requests on `unitClassId` in an open status.
 */
const hasOpenRequestInWindow = (openRows, unitClassId, config, at = new Date()) => {
    const targetWindow = (0, dealingWindow_1.dealingWindowKeyFor)((0, dealingWindow_1.deriveDealingWindows)(config, at, 1)[0]?.dealingDayKey ?? "", unitClassId);
    return openRows.some((row) => row.dealingWindowKey === undefined || row.dealingWindowKey === targetWindow);
};
exports.hasOpenRequestInWindow = hasOpenRequestInWindow;
//# sourceMappingURL=investorRules.js.map